module.exports = __webpack_public_path__ + "img/logo.174c70f.png";